import { IconTypes } from '@eika/icon';
export const taskManagerIconSelector = (subType) => {
    switch (subType) {
        case 'UPLOAD_DOCUMENTATION':
            return IconTypes.KLOKKE_24;
        case 'SIGN':
        case 'CONFIRM':
            return IconTypes.USP_CHECKMARK_24;
        default:
            return IconTypes.PENN_24;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFza01hbmFnZXJJY29uU2VsZWN0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvd2lkZ2V0cy9LcmVkaXR0YmFua2VuQ3VzdG9tZXJUYXNrcy90YXNrTWFuYWdlckljb25TZWxlY3Rvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBSXZDLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLENBQUMsT0FBNEIsRUFBYSxFQUFFO0lBQy9FLFFBQVEsT0FBTyxFQUFFLENBQUM7UUFDZCxLQUFLLHNCQUFzQjtZQUN2QixPQUFPLFNBQVMsQ0FBQyxTQUFTLENBQUM7UUFDL0IsS0FBSyxNQUFNLENBQUM7UUFDWixLQUFLLFNBQVM7WUFDVixPQUFPLFNBQVMsQ0FBQyxnQkFBZ0IsQ0FBQztRQUN0QztZQUNJLE9BQU8sU0FBUyxDQUFDLE9BQU8sQ0FBQztJQUNqQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDIn0=